import { render, staticRenderFns } from "./EvoPerf.vue?vue&type=template&id=23ad8ae6&scoped=true"
import script from "./EvoPerf.vue?vue&type=script&lang=js"
export * from "./EvoPerf.vue?vue&type=script&lang=js"
import style0 from "./EvoPerf.vue?vue&type=style&index=0&id=23ad8ae6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ad8ae6",
  null
  
)

export default component.exports